module.exports = __webpack_public_path__ + "static/img/honorTop.8777b8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/honorTop.png
// module id = WgAW
// module chunks = 0